"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = { qrcodeSrc: null };
        fhandler.bind(this, { keep_signed: true });
    },
    onMount: async function () {
        let location;
        try {
            location = await getClientLocation();
        } catch (error) {
            console.log('Get Client Location Error: ', error);
            throw new Error('We are having trouble getting your location. Try again');
        }
        UISocket.on('APP::PROCEED_QRCODE_SIGNIN', fn => {
            console.log('Proceed QR Code');
            fn({
                device: window.Device,
                userAgent: window.UserAgent,
                location
            });
        }).on('APP::GRANTED_ACCESS', credentials => {
            console.log('response: ', credentials);
            credentials.keepSigned = this.state.form.keep_signed;
            this.grantAccess(credentials);
        }).emit('APP::GET_QRTOKEN', qrcodeSrc => this.state.qrcodeSrc = qrcodeSrc);
    },
    grantAccess: function (credentials) {
        let queries = Obj2Params(credentials);
        if (isDefaultDomain())
            queries += '&redirectTo=/onboarding';
        else {
            if (this.input.params.hasOwnProperty('redirectTo'))
                queries += '&redirectTo=' + encodeURIComponent(this.input.params.redirectTo);
        }
        document.location = `/authorize?${ queries }`;
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Auth/QRSignin.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_FormHandler = require("markojs-form"),
    FormHandler = module_FormHandler.default || module_FormHandler,
    Image_template = require("../../../components/Image/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Image_tag = marko_loadTag(Image_template),
    Wrapper_template = require("../../../components/Wrapper/index.marko"),
    Wrapper_tag = marko_loadTag(Wrapper_template),
    marko_attrs0 = {
        id: "auth-login",
        "class": "d-flex height-100vh justify-content-center align-items-center center animated fast zoomIn"
      },
    marko_attrs1 = {
        "class": "col-xl-8 col-lg-10 col-12"
      },
    marko_attrs2 = {
        "class": "mb-0"
      },
    marko_attrs3 = {
        "class": "row m-0"
      },
    marko_attrs4 = {
        "class": "col-12 h-100 d-flex justify-content-center"
      },
    marko_attrs5 = {
        "class": "col-md-5 col-12 text-center"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("d28ac0"),
    marko_node0 = marko_createElement("img", {
        src: "/images/favicon/logo-uplogo.png",
        width: "150"
      }, "7", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "8", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node2 = marko_createElement("br", null, "9", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node3 = marko_createElement("br", null, "10", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs6 = {
        "class": "border round p-5"
      },
    marko_attrs7 = {
        "class": "card-content"
      },
    marko_node4 = marko_createElement("h5", {
        "class": "mt-0"
      }, "14", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Signin with QR-Code"),
    marko_node5 = marko_createElement("br", null, "15", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs8 = {
        "class": "position-relative"
      },
    marko_node6 = marko_createElement("br", null, "18", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node7 = marko_createElement("p", {
        "class": "blue-grey-text px-2"
      }, "19", null, 5, 0, {
        i: marko_const_nextId()
      })
      .t("Open your mobile application, click on ")
      .e("span", {
          "class": "black-text"
        }, null, null, 1)
        .t("Menu")
      .t(" and select ")
      .e("span", {
          "class": "black-text"
        }, null, null, 1)
        .t("QR-Code Signin")
      .t(" option, then scan this QR-Code to get signed in."),
    marko_node8 = marko_createElement("br", null, "22", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs9 = {
        "class": "checkbox checkbox-primary"
      },
    marko_node9 = marko_createElement("label", {
        "for": "keep-signed"
      }, "26", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Keep me signed in");

const fhandler = new FormHandler();

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_tag({
      scroll: true,
      renderBody: function(out) {
        out.be("section", marko_attrs0, "1", component);

        out.be("div", marko_attrs1, "2", component);

        out.be("div", marko_attrs2, "3", component);

        out.be("div", marko_attrs3, "4", component);

        out.be("div", marko_attrs4, "5", component);

        out.be("div", marko_attrs5, "6", component);

        out.n(marko_node0, component);

        out.n(marko_node1, component);

        out.n(marko_node2, component);

        out.n(marko_node3, component);

        out.be("div", marko_attrs6, "11", component);

        out.be("div", marko_attrs7, "12", component);

        out.be("form", null, "13", component);

        out.n(marko_node4, component);

        out.n(marko_node5, component);

        out.be("div", marko_attrs8, "16", component);

        Image_tag({
            alt: "qrcode-image",
            class: "img-fluid",
            src: state.qrcodeSrc || "/images/qrcode/placeholder.jpg"
          }, out, __component, "17");

        out.ee();

        out.n(marko_node6, component);

        out.n(marko_node7, component);

        out.n(marko_node8, component);

        out.e("div", null, "23", component, 1)
          .e("div", marko_attrs9, "24", component, 2)
            .e("input", {
                type: "checkbox",
                id: "keep-signed",
                name: "keep_signed",
                checked: state.form.keep_signed
              }, "25", component, 0, 0, {
                onchange: __component.d("change", "__onChecked", false)
              })
            .n(marko_node9, component);

        out.ee();

        out.ee();

        out.ee();

        out.ee();

        out.ee();

        out.ee();

        out.ee();

        out.ee();

        out.ee();
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
